var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67962 2.89932L4.87184 0.707107C5.26236 0.316583 5.89553 0.316583 6.28605 0.707107L10.135 4.55605C10.5255 4.94658 10.5255 5.57974 10.135 5.97026L7.55327 8.552C7.16 8.94526 7.0625 9.54606 7.31123 10.0435C8.74906 12.9192 11.0808 15.2509 13.9565 16.6888C14.4539 16.9375 15.0547 16.84 15.448 16.4467L18.0297 13.865C18.4203 13.4745 19.0534 13.4745 19.4439 13.865L23.2929 17.7139C23.6834 18.1045 23.6834 18.7376 23.2929 19.1282L21.1007 21.3204C18.9893 23.4317 15.6468 23.6693 13.258 21.8777L9.52331 19.0767C7.77978 17.769 6.23096 16.2202 4.92331 14.4767L2.12226 10.742C0.330722 8.35324 0.568271 5.01068 2.67962 2.89932Z",
    fill: "#EE2D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.b133c825.svg";
export { ForwardRef as ReactComponent };